import { useRef, useState } from 'react';
import Filter from './Filter';
import styles from "./FilterList.module.css";
import { filterDTO } from '../../types';

function FilterList({ items }: AccordionProps ) {
  const resetActiveFilterTabs = -1;
  const [currentActiveFilterTabId, setCurrentActiveFilterTabId] = useState(resetActiveFilterTabs);
  const setActiveFilterTab = (filterTabId: number) => {
    currentActiveFilterTabId === filterTabId ? setCurrentActiveFilterTabId(resetActiveFilterTabs) : setCurrentActiveFilterTabId(filterTabId);
  };

  const refs = useRef([]);

  return (
    <ul className={`${styles.accordion}`}>
      {items.map((item, idx) => (
        <Filter
          key={idx}
          data={item}
          isOpen={idx === currentActiveFilterTabId}
          setActiveFilterTab={() => setActiveFilterTab(idx)}
          filterNumber={idx}
        />
      ))}
    </ul>
  );
}

export default FilterList;

interface AccordionProps{
    items: filterDTO [];
}